import { LineDirectionX, LineDirectionY } from 'types'

export const BOUNDS_U = [0, 1]
export const BOUNDS_V = [0, 1]

export const segmentAlongXBoundary = (startU: number, endU: number) =>
  startU === endU && (startU === BOUNDS_U[1] || startU === BOUNDS_U[0])
export const segmentAlongYBoundary = (startV: number, endV: number) =>
  startV === endV && (startV === BOUNDS_V[1] || startV === BOUNDS_V[0])

export const crossesXBoundary = (
  startU: number,
  endU: number | undefined,
  xDirection: LineDirectionX
): boolean => {
  if (endU === undefined || segmentAlongXBoundary(startU, endU)) return false
  return (
    xDirection !== LineDirectionX.None &&
    (startU === endU || startU < endU !== (xDirection === LineDirectionX.Right))
  )
}

export const crossesYBoundary = (
  startV: number,
  endV: number | undefined,
  yDirection: LineDirectionY
): boolean => {
  if (endV === undefined || segmentAlongYBoundary(startV, endV)) return false
  return (
    yDirection !== LineDirectionY.None &&
    (startV === endV || startV < endV !== (yDirection === LineDirectionY.Up))
  )
}
